import { z } from 'zod';
import { PAGINATION } from '../constants/app';

/** 通用分页查询。所有列表接口复用，避免各写一份并出现上限不一致。 */
export const pageQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce
    .number()
    .int()
    .min(1)
    .max(PAGINATION.maxPageSize)
    .default(PAGINATION.defaultPageSize),
});
export type PageQuery = z.infer<typeof pageQuerySchema>;

/** 路径参数 :id。id 为 ULID/uuid 字符串。 */
export const idParamSchema = z.object({
  id: z.string().min(1).max(64),
});
export type IdParam = z.infer<typeof idParamSchema>;

/** 文章导入时必须显式确认版权，否则返回 COPYRIGHT_ACK_REQUIRED。 */
export const copyrightAckSchema = z.object({
  acknowledgeCopyright: z.literal(true, {
    errorMap: () => ({ message: '请先确认你拥有该文本的使用授权' }),
  }),
});
